import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface Restriction {
  type?: string;
  name: string;
}

export interface RestrictionWarningData {
  warningType?: 'restriction' | 'requirement';
  title?: string;
  message?: string;
  restrictions?: Restriction[];
}

@Component({
  selector: 'kt-restriction-warning-dialog',
  templateUrl: './restriction-warning-dialog.component.html',
  styleUrls: ['./restriction-warning-dialog.component.scss']
})
export class RestrictionWarningDialogComponent {

  warningType: 'restriction' | 'requirement';
  title: string;
  message: string;
  restrictions: Restriction[];

  constructor(
    public dialogRef: MatDialogRef<RestrictionWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RestrictionWarningData
  ) {
    const {
      warningType = 'restriction',
      title = 'Are you sure?',
      message = 'Player did not meet the following requirement,<br>are you sure you want to continue?',
      restrictions = []
    } = data || {};

    this.warningType = warningType;
    this.title = title;
    this.message = message;
    this.restrictions = restrictions;
  }

  
  onYes(): void {
    this.dialogRef.close({ action: 'yes' });
  }

  onNo(): void {
    this.dialogRef.close({ action: 'no' });
  }

  private static openDialog(
    dialog: MatDialog,
    data: RestrictionWarningData
  ): MatDialogRef<RestrictionWarningDialogComponent> {
    return dialog.open(RestrictionWarningDialogComponent, {
      width: '400px',
      disableClose: false,
      data
    });
  }

  static openFromRestrictions(
    dialog: MatDialog,
    response: any
  ): MatDialogRef<RestrictionWarningDialogComponent> {

    const restrictionTypeMap: Record<string, string> = {
      MINIMUM_TRANSFER: 'Minimum Transfer',
      DAILY_LIMIT: 'Daily Limit',
      PLAYER_LIFETIME_LIMIT: 'Player Lifetime Limit',
      KYC_REQUIREMENT: 'KYC Requirement',
      LAST_DEPOSIT_REQUIREMENT: 'Last Deposit Requirement',
      ACTIVE_BONUS_ROUND: 'Active Bonus Round'
    };

    const restrictions =
      response?.data?.restrictions?.map((r: any) => ({
        type: r.type,
        name: restrictionTypeMap[r.type] || r.type
      })) || [];

    return this.openDialog(dialog, {
      warningType: 'restriction',
      restrictions
    });
  }

  static openFromError(
    dialog: MatDialog,
    error: any
  ): MatDialogRef<RestrictionWarningDialogComponent> {

    const backendRestrictions = error?.error?.data?.restrictions;

    if (Array.isArray(backendRestrictions) && backendRestrictions.length > 0) {
      return this.openFromRestrictions(dialog, {
        data: { restrictions: backendRestrictions }
      });
    }

    let message = error?.error?.message || error?.message;

    if (Array.isArray(message)) {
      message = message.join(' ');
    }

    return this.openDialog(dialog, {
      warningType: 'requirement',
      restrictions: [
        { name: message || 'Player did not meet the required conditions' }
      ]
    });
  }
}